import client from './client';

const caApi = {
  getToday()              { return client.get('/ca/today').then(r => r.data); },
  getDaily(date)          { return client.get(`/ca/daily/${date}`).then(r => r.data); },
  getDates()              { return client.get('/ca/dates').then(r => r.data.dates); },
  getByCategory(cat, p)   { return client.get(`/ca/category/${cat}`, { params: p }).then(r => r.data); },
  search(q, p)            { return client.get('/ca/search', { params: { q, ...p } }).then(r => r.data); },
  getMonthly(year, month) { return client.get(`/ca/monthly/${year}/${month}`).then(r => r.data); },
  getBySlug(slug)         { return client.get(`/ca/${slug}`).then(r => r.data); },

  // Monthly PDFs
  getPDFs()               { return client.get('/ca-pdfs').then(r => r.data.data); },
  getDownloadUrl(id)      { return `${client.defaults.baseURL}/ca-pdfs/${id}/download`; },
};

export default caApi;
